export const getCurrencyIcon = () => {
    const currentCountry = sessionStorage.getItem('country');
    if (currentCountry === "India")
        return '₹'
    return '฿'
}